// Saudi cities list - الرياض is the only city with delivery coverage
const SAUDI_CITIES = [
  { value: "الرياض", labelAr: "الرياض", labelEn: "Riyadh" },
  { value: "جدة", labelAr: "جدة", labelEn: "Jeddah" },
  { value: "مكة المكرمة", labelAr: "مكة المكرمة", labelEn: "Makkah" },
  { value: "المدينة المنورة", labelAr: "المدينة المنورة", labelEn: "Madinah" },
  { value: "الدمام", labelAr: "الدمام", labelEn: "Dammam" },
  { value: "الخبر", labelAr: "الخبر", labelEn: "Khobar" },
  { value: "الطائف", labelAr: "الطائف", labelEn: "Taif" },
  { value: "تبوك", labelAr: "تبوك", labelEn: "Tabuk" },
  { value: "بريدة", labelAr: "بريدة", labelEn: "Buraidah" },
  { value: "خميس مشيط", labelAr: "خميس مشيط", labelEn: "Khamis Mushait" },
  { value: "حائل", labelAr: "حائل", labelEn: "Hail" },
  { value: "نجران", labelAr: "نجران", labelEn: "Najran" },
  { value: "جازان", labelAr: "جازان", labelEn: "Jazan" },
  { value: "ينبع", labelAr: "ينبع", labelEn: "Yanbu" },
  { value: "أبها", labelAr: "أبها", labelEn: "Abha" },
  { value: "الجبيل", labelAr: "الجبيل", labelEn: "Jubail" },
  { value: "القطيف", labelAr: "القطيف", labelEn: "Qatif" },
  { value: "الأحساء", labelAr: "الأحساء", labelEn: "Al Ahsa" },
];

// Cities that have delivery coverage
const COVERED_CITIES = ["الرياض"];

export const isCityCovered = (city) => {
  return COVERED_CITIES.includes(city);
};

export default SAUDI_CITIES;
